import React from "react";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import gameHeaderStyles from "../../common/styles/sports/GameHeader.styles";

const GameHeader = ({ title, description }) => {
	const classes = gameHeaderStyles();

	return (
		<Grid
			container
			justifyContent="space-between"
			alignItems="center"
			className={classes.root}
		>
			<Grid item md={6}>
				<Typography variant="h3" className={classes.title}>
					{title}
				</Typography>
				<Typography variant="body1" className={classes.description}>
					{description}
				</Typography>
			</Grid>
		</Grid>
	);
};

export default GameHeader;
